import type { LessonAndAssessmentResult } from '../core/type';

import { AssessmentsComp } from '../components/AssessmentsComp';
import { LearnerScoreLayout } from '../components/LearnerScoreLayout';
import { LessonsComp } from '../components/LessonsComp';
import { useLearnerScoreController } from '../core/controller/learner-score';
import { LEARNER_SCORE } from '../core/enum';
import { getLearnerScoresTabs } from '../core/tabs';

export const LearnerScorePage = () => {
  const tabs = getLearnerScoresTabs();

  const { activeKey, onTabClick, goBack, data } = useLearnerScoreController();

  if (!data) {
    return null;
  }

  return (
    <div>
      <LearnerScoreLayout
        tabs={tabs}
        activeKey={activeKey}
        onTabClick={onTabClick}
        goBack={goBack}
        data={data as LessonAndAssessmentResult}
      />
      <div style={{ marginTop: 40, width: 'calc(100% - 156px)' }}>
        {activeKey === LEARNER_SCORE.LESSONS ? (
          <LessonsComp lessonResult={data?.lessons ?? []} />
        ) : (
          <AssessmentsComp assessmentResult={data?.assessments ?? []} />
        )}
      </div>
    </div>
  );
};
